import React, { useState } from 'react'
import { Button, Col, Row, Image, Space } from 'antd'

const ExpandedData = ({ data }) => {

    const [isImageVisible, setIsImageVisible] = useState(false)
    const [selectedImage, setSelectedImage] = useState("")

    const handleImageClick = (image) => { setSelectedImage(image); setIsImageVisible(true) }

    const tableData = [
        { heading: "Title", data: data.title },
        { heading: "Slug", data: <a href={`http://localhost:3000/blog/${data.slug}`} target="_blank" rel="noopener noreferrer">{data.slug}</a> },
        { heading: "Description", data: data.description },
        // { heading: "Last", data: window.dateFormat(data.lastD, "dddd DD-MMM-YYYY") },
        { heading: "Sort Order", data: data.sortOrder },
        { heading: "Status", data: data.status, className: "text-capitalize" },
        { heading: "Date Created", data: window.dateFormat(data.createdAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        { heading: "Date Updated", data: window.dateFormat(data.updatedAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        { heading: "Banner", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.bannerURL) }}>Click to See</Button> },
        { heading: "Image", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.imageURL) }}>Click to See</Button> },
        {
            heading: "Blog Content",
            data: <div dangerouslySetInnerHTML={{ __html: data.blogContent }} />
        },
    ]

    const tableComponent = (heading, array) => {
        return <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover align-middle mb-0">
                <tbody>
                    <tr><th colSpan={2} className='text-center'>{heading}</th></tr>
                    {array.map((row, i) => {
                        return <tr key={i}>
                            <th style={{ minWidth: 180 }}>{row.heading}</th>
                            <td className={row.className || ""}>{row.data}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    return (
        <>
            <Row>
                <Col xs={24} lg={{ span: 14, offset: 5 }}>
                    <Space direction="vertical" size="large" className='w-100'>
                        {tableComponent("Blog Details", tableData)}
                    </Space>
                </Col>
            </Row>

            <Image preview={{ visible: isImageVisible, src: selectedImage, onVisibleChange: (value) => { setIsImageVisible(value) } }} />
        </>
    )
}

export default ExpandedData